import * as React from "react";

const TextItem = ({ children }) => <span className="text-item">{children}</span>;

const textItems = Array(10).fill("WE ARE SPOELT");

export function Banner() {
  return (
    <>
      <nav className="navigation">
        {textItems.map((item, index) => (
          <TextItem key={index}>{item}</TextItem>
        ))}
      </nav>

      <style jsx>{`
        .navigation {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          padding-right: 20px;
          gap: 20px;
          font-size: 14px;
          color: #202023;
          font-weight: 400;
          letter-spacing: 0.28px;
          line-height: 130%;
        }

        @media (max-width: 991px) {
          .navigation {
            flex-wrap: wrap;
          }
        }

        .text-item {
          font-family: Metrophobic, sans-serif;
          min-height: 30px; /* Adjust based on your content */
          padding: 5px;
          margin: 2px;
        }
      `}</style>
    </>
  );
}

